// Main JS file
window.addEventListener('load', function () {
	const svgEl = document.querySelectorAll('.banner-svg');
	svgEl.forEach((element) => (element.style.opacity = 1));
});
gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(ScrollTrigger);
